<template>
  <div class="side-bar">
    <div class="icon">
      <img src="../../assets/images/talent-logo-default-monochrome.svg" alt="talent-logo" />
      <div class="closeToggle" v-on:click="$emit('toggleSidebar')"></div>
    </div>
    <ul>
      <li
        v-bind:key="menu.title"
        v-for="menu in sidebarMenus"
        v-bind:class="{ activate: active && showDark[menu.title] }"
      >
        <button v-bind:id="menu.title" @click="[toggleActive(menu.title), $emit('toggleSidebar')]">
          <span class="icon-container">
            <img v-bind:src="menu.icon" v-if="!showDark[menu.title]" alt="hamburger icon" />
            <img v-bind:src="menu.darkIcon" v-if="showDark[menu.title]" alt="hamburger icon" />
          </span>
          <span class="title">{{ menu.title }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'DashboardSidebar',
  props: ['sidebarMenus', 'touchSidebarButton', 'userType'],
  data() {
    return {
      active: true,
      showDark: { Dashboard: 'Dashboard' },
    };
  },
  watch: {
    touchSidebarButton: function () {
      const currentPathName = this.$router.history.current.name;
      this.toggleActive(currentPathName);
    },
  },
  methods: {
    toggleActive(data) {
      this.showDark = {};
      this.showDark[data] = data;
      this.$emit('toBeDisplayed', data);
      let buttonName = document.getElementById(data);
      buttonName ?
      buttonName.classList.toggle('activate') : null;
      this.active = true;

    },
  },
};
</script>

<style scoped>
.side-bar {
  width: 18%;
  height: 100vh;
  position: fixed;
  z-index: 10;
  background: linear-gradient(178.52deg, #025fa0 191.02%, #2b3d6e 1.26%);
  transition: 0.25s;
  transform: translateY(0);
  transition-timing-function: ease-out;
  overflow-y: auto;
}
.side-bar.active {
  position: absolute;
  left: -25rem;
}
.closeToggle {
  /* width: 3.75rem; */
  height: 3.75rem;
  display: none;
  cursor: pointer;
}
.closeToggle:before {
  content: "\f00d";
  font-family: fontAwesome;
  line-height: 3.75rem;
  padding: 0.9375rem 0.9375rem 0.9375rem 1.25rem;
  font-size: 1.2rem;
  color: #e5e5e5;
  position: absolute;
  top: 0;
  right: 0;
}
.side-bar .icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  margin-top: 2.625rem;
}
.side-bar .icon img {
  /* width: 8.625rem; */
  width: 9rem;
}
.side-bar ul {
  width: 100%;
}
.side-bar ul li {
  position: relative;
  width: 100%;
  color: var(--white);
  height: 4.5rem;
}
.side-bar ul li button {
  width: 100%;
  display: flex;
  font-family: "montserrat";
  padding: 0 2rem;
  text-align: center;
  color: var(--white);
  background: none;
  border: none;
  align-items: center;
  height: 5rem;
}
.side-bar ul li button .icon-container {
  margin-right: 1.5rem;
}
.side-bar ul li button .title {
  height: 1.375rem;
  line-height: 1.371rem;
  font-size: 1.125rem;
}
.activate > button {
  background: var(--white) !important;
  color: #2b3d6e !important;
  font-weight: 600;
  background: var(--white);
  box-shadow: 0.3125rem 0px 0.25rem rgba(0, 0, 0, 0.05);
}

@media only screen and (max-width: 1260px) {
  .side-bar ul li button {
    padding: 0 1.35rem;
  }

  /* .side-bar ul li button .title {
      font-size: 20px;
    } */
}

@media only screen and (max-width: 1096px) {
  .side-bar ul li button .title {
    font-size: 18px;
  }
}

@media only screen and (max-width: 990px) {
  .side-bar .icon img {
    max-width: 6.25rem;
  }
  .side-bar ul li button {
    padding: 0 1.2rem;
  }
  .side-bar ul li button .title {
    font-size: 16px;
  }
}

@media only screen and (max-width: 840px) {
  .side-bar ul li button {
    padding: 0 1rem;
  }
  .side-bar ul li button .title {
    font-size: 13.33px;
  }
}

@media only screen and (max-width: 767px) {
  .closeToggle {
    display: block;
  }
  .side-bar {
    position: absolute;
    left: -25rem;
  }
  .side-bar .icon {
    margin: 2.625rem 0;
  }
  .side-bar.active {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    transition: 0.3s;
    transition-timing-function: ease-in;
  }
  .side-bar ul li button .title {
    font-size: 18px;
  }
}

</style>
